export default{
    id: null,
    error: false,
    errorMessage:'',
    jwt:'',
    secret:'',
    msg:'',
    access:false,
    status:'',
}